<template>
  <div class="policiesregulationsdetail">
    <header-view :tabsign="7"></header-view>
    <div class="body w12 min-h">
	  <div class="toptitle">
	  	<div class="left_c">
	  		<div class="redcon"></div>
	  		<span>政策法规</span>
	  	</div>
	  	<div class="right_c"></div>
	  </div>
	  
      <div class="noticeDetailstitle">{{ Institutional.title == undefined?'':Institutional.title}}</div>
      <div class="subtitle">
        <!-- <span>作者：{{Institutional.createBy == undefined?'':Institutional.createBy}}</span> -->
        <span> 发布时间：{{Institutional.createTime == undefined?'':Institutional.createTime}}</span>
        <!-- <span>阅读：{{Institutional.views == undefined?'':Institutional.views}}</span> -->
      </div>
      <div v-html="Institutional.content" class="msg" style="margin-bottom: 100px;"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "policiesregulationsdetail",

  data: function() {
    return {
      Institutional: "",
      query: ""
    };
  },
  created() {
    this.query = this.$route.query;
	this.init();
  },
  mounted() {
    // this.add();
	window.pageYOffset = 0;
	document.documentElement.scrollTop = 0;
	document.body.scrollTop = 0;	
  },
  methods: {
    init() {
      var that = this;
      this.httpGet("web/info/queryById", {
         id: this.query.id
      }).then(res => {
         that.Institutional = res.result;
      });
    },
    add() {
      this.httpPut("web/annountCement/eidtViews", {
         id: this.query.id
      });
    }
  }
};
</script>
<style scoped lang="scss">
.policiesregulationsdetail {
  ::-webkit-scrollbar { width: 0px !important }
  width: 100%;
  position: relative;
  .body {
    background: #ffffff;
    margin: 120px auto 0px;
	.toptitle{
		height: 60px;
		border-bottom: 1px solid #ededed;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.left_c{
			display: flex;
			align-items: center;
			.redcon{
				width: 5px;
				height:20px;
				background: #E70012;
				margin-right: 20px;
			}
			font-size:25px;
			font-weight: 400;
			color: #E61F26;
		}
	}
    .noticeDetailstitle {
      margin-top: 17px;
      font-size:28px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      text-align: center;
    }
    .subtitle {
      text-align: center;
      margin-top:21px;
      font-size:14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      span {
        display: inline-block;
        margin-right: 40px;
        margin-bottom:45px;
      }
    }
    .msg {
      width: 1040px;
      margin: 0px auto;
    }
  }
}
</style>
